import color from '../../../../color';

const colors = [
  color.emphasis,
  color.electricIndigo,
  color.sunglow,
  color.brightYellow,
  color.carminePink,
  color.androidGreen,
  color.pearlyPurple,
  color.vividCerulean,
  color.toolbox,
  color.deer,
  color.grayXL,
  color.darkVanilla,
];

export const getColorByIndex = (index: number): string =>
  colors[index] || color.grayL;
